import React, { useState, useEffect } from "react";
import { useLang } from "@/context/LangContext";
import Header from "@/components/app/Header";
import PatientFlow from "@/components/app/PatientFlow";
import DoctorPortal from "@/components/app/DoctorPortal";
import { Toaster } from "@/components/ui/sonner";
import "@/App.css";

export default function App() {
  const { lang } = useLang();
  const [view, setView] = useState("patient");
  const [kiosk, setKiosk] = useState(true);

  useEffect(() => {
    document.documentElement.lang = lang;
  }, [lang]);

  return (
    <div
      className={`min-h-screen bg-slate-50 text-slate-900 antialiased ${kiosk ? "kiosk-mode" : ""} ${
        lang === "hi" ? "font-hi" : lang === "ta" ? "font-ta" : "font-base"
      }`}
    >
      <Header view={view} setView={setView} kiosk={kiosk} setKiosk={setKiosk} />
      <main className="mx-auto max-w-7xl px-4 py-6 sm:px-6 lg:px-8">
        {view === "patient" ? <PatientFlow kiosk={kiosk} /> : <DoctorPortal />}
      </main>
      <Toaster position="top-right" richColors closeButton />
      <footer className="border-t border-slate-200 bg-white/60 py-4 text-center text-xs text-slate-500">
        PulseFlow Hospital · Dual-mode Kiosk / Mobile · Multi-language (EN/HI/TA)
      </footer>
    </div>
  );
}
